import React from 'react';
import { SimpleEditor } from '@/components/tiptap-templates/simple/simple-editor';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface SimpleEditorWrapperProps {
  value?: string;
  onChange?: (content: string) => void;
  title?: string;
  onTitleChange?: (title: string) => void;
  subtitle?: string;
  onSubtitleChange?: (subtitle: string) => void;
  placeholder?: string;
  className?: string;
  editable?: boolean;
}

export function SimpleEditorWrapper({
  value = '',
  onChange,
  title,
  onTitleChange,
  subtitle,
  onSubtitleChange,
  placeholder = 'Start writing...',
  className,
  editable = true,
}: SimpleEditorWrapperProps) {
  const aiEnabled = true; // Always enabled

  return (
    <div className={cn('flex flex-col h-full overflow-hidden', className)}>
      {/* Title Input */}
      {onTitleChange && (
        <div className="flex-shrink-0 p-4 border-b bg-background/30 backdrop-blur-sm">
          <Input
            value={title || ''}
            onChange={(e) => onTitleChange(e.target.value)}
            placeholder="Note title..."
            className="text-2xl font-bold border-none shadow-none px-0 focus-visible:ring-0 bg-transparent"
          />
        </div>
      )}

      {/* Subtitle Input */}
      {onSubtitleChange && (
        <div className="flex-shrink-0 px-4 pb-4 bg-background/30 backdrop-blur-sm">
          <Input
            value={subtitle || ''}
            onChange={(e) => onSubtitleChange(e.target.value)}
            placeholder="Add a subtitle..."
            className="text-lg text-muted-foreground border-none shadow-none px-0 focus-visible:ring-0 bg-transparent"
          />
        </div>
      )}

      {/* Editor - Takes remaining space and allows internal scrolling */}
      <div className="flex-1 min-h-0 overflow-hidden">
        <SimpleEditor
          content={value}
          onChange={onChange}
          placeholder={placeholder}
          editable={editable}
          enableAI={aiEnabled}
          className="h-full"
        />
      </div>
    </div>
  );
}